import React from 'react';

export default function PlatformSettings() {
  const tenant = JSON.parse(localStorage.getItem('platform_tenant') || '{}');

  return (
    <div className="max-w-2xl" data-testid="platform-settings-page">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Outfit, sans-serif' }}>Settings</h1>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6" data-testid="account-details-section">
        <h3 className="text-base font-semibold text-gray-900 mb-4">Account Details</h3>
        <div className="space-y-3">
          <div className="flex justify-between py-2 border-b border-gray-100">
            <span className="text-sm text-gray-500">Business Name</span>
            <span className="text-sm font-medium text-gray-900" data-testid="settings-business-name">{tenant.name || '\u2014'}</span>
          </div>
          <div className="flex justify-between py-2 border-b border-gray-100">
            <span className="text-sm text-gray-500">Slug</span>
            <code className="text-sm font-mono text-gray-700" data-testid="settings-slug">{tenant.slug || '\u2014'}</code>
          </div>
          <div className="flex justify-between py-2 border-b border-gray-100">
            <span className="text-sm text-gray-500">Status</span>
            <span className="text-sm font-medium text-gray-900" data-testid="settings-status">{tenant.status || '\u2014'}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-sm text-gray-500">Support</span>
            <a href="mailto:support@pebbles.financial" className="text-sm text-[#E8678B] hover:underline">support@pebbles.financial</a>
          </div>
        </div>
      </div>
    </div>
  );
}
